import { useEffect } from 'react'
import {
  supabaseGestionPension as supabase,
} from '../../../../config/settings/supabase-client'
import { startTracking, stopTracking } from './presenceHeartbeat'

const PresenceTracker = () => {
  useEffect(() => {
    let cancelled = false

    supabase.auth.getSession().then(({ data }) => {
      if (cancelled) return
      const userId = data.session?.user?.id
      if (userId) startTracking(userId)
    })

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_OUT') {
          stopTracking()
          return
        }
        if (
          event === 'INITIAL_SESSION' ||
          event === 'SIGNED_IN' ||
          event === 'TOKEN_REFRESHED'
        ) {
          const userId = session?.user?.id
          if (userId) startTracking(userId)
        }
      }
    )

    return () => {
      cancelled = true
      listener.subscription.unsubscribe()
      stopTracking()
    }
  }, [])

  return null
}

export default PresenceTracker
